import { render } from "./Loan_Applications.vue?vue&type=template&id=4b188782&scoped=true"
import script from "./Loan_Applications.vue?vue&type=script&lang=js"
export * from "./Loan_Applications.vue?vue&type=script&lang=js"

import "./Loan_Applications.vue?vue&type=style&index=0&id=4b188782&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b188782"]])

export default __exports__